/* eslint-disable security/detect-object-injection */

import { PROPERTY_TEMPLTES } from '@/screens/Order/constant/property_template'
import { ISectionProperty } from '@/screens/Order/interface/common.interface'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Collapse, Input, notification, Popconfirm, Select } from 'antd'
import { last, orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import './WorkFlowForm.style.less'

const { Panel } = Collapse

interface PropsHeader {
  onChangeName: (value: string) => void
  value: ISectionProperty
  onDeleteSection: () => void
}

const handleFocus = (event) => {
  event.stopPropagation()
}

function CollapseHeader(props: PropsHeader) {
  return (
    <div className="section">
      <p className="label-name">Section Name</p>
      <Input
        onClick={handleFocus}
        size="large"
        value={props.value.name}
        onChange={(e) => props.onChangeName(e.target.value)}
      />
      <Popconfirm
        placement="topLeft"
        title={'Are you sure you want to delete this section?'}
        onConfirm={props.onDeleteSection}
        okText="Yes"
        cancelText="No"
      >
        <Button
          onClick={handleFocus}
          className="delete-button"
          size="large"
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    </div>
  )
}

interface Props {
  setSection: (value) => void
  sections: any
  isImport: boolean
  isCreateNew?: boolean
}

function WorkFlowForm(props: Props) {
  const [sections, setsections] = useState<Array<ISectionProperty | any>>([])

  useEffect(() => {
    const tmpSection = props.sections.map((item) => {
      return {
        ...item,
        tasks: orderBy(item.tasks, ['display_order'], ['asc']),
      }
    })
    setsections(orderBy(tmpSection, ['display_order'], ['asc']))
  }, [props.isImport])

  const onSectionNameChange = (value, index) => {
    const tmp = [].concat(sections)
    tmp[index].name = value
    setsections(tmp)
  }

  const onAddSection = () => {
    setsections([
      ...sections,
      {
        name: '',
        tasks: [],
        display_order: last(sections) ? last(sections).display_order + 1 : 0,
      },
    ])
  }

  const onAddSubSection = (index) => {
    const tmp: any = [].concat(orderBy(sections, ['display_order'], ['asc']))
    tmp[index].tasks.push({
      value: '',
      name: '',
      type: '',
      plan_date: null,
      tasks_progress: 'new',
      display_order: last(tmp[index].tasks)
        ? (last(tmp[index].tasks) as any).display_order + 1
        : 0,
      json_value: {},
      is_template: false,
    })
    setsections(tmp)
  }

  const onSubSectionNameChange = (value, indexSection, index) => {
    const tmp = [].concat(sections)
    tmp[indexSection].tasks[index].name = value
    setsections(tmp)
  }

  const onSubSectionControlTypeChange = (value, indexSection, index) => {
    const tmp = [].concat(sections)
    tmp[indexSection].tasks[index].type = value
    setsections(tmp)
  }

  const onDeleteSection = (index) => {
    if (!props.isCreateNew) {
      if (sections.length == 1) {
        return notification.warn({
          message: `Cannot remove the last section of time and action`,
          placement: 'bottom',
          duration: 3,
        })
      }
    }
    const tmp = [].concat(sections)
    tmp.splice(index, 1)
    setsections(tmp)
  }

  const onDeleteSubSection = (indexSection, indexSubSection) => {
    const tmp = [].concat(sections)
    tmp[indexSection].tasks.splice(indexSubSection, 1)
    setsections(tmp)
  }

  useEffect(() => {
    props.setSection(orderBy(sections, ['display_order'], ['asc']))
  }, [sections])

  return (
    <div className="pbf-workflow-container">
      <Collapse expandIconPosition="right">
        {sections.length == 0 && (
          <p className="place-holder-text">
            * Start creating your workflow by adding a section
          </p>
        )}
        {orderBy(sections, ['display_order'], ['asc']).map(
          (item: any, index) => {
            return (
              <Panel
                header={
                  <CollapseHeader
                    value={item}
                    onChangeName={(value) => onSectionNameChange(value, index)}
                    onDeleteSection={() => onDeleteSection(index)}
                  />
                }
                key={index}
              >
                {orderBy(item.tasks, ['display_order'], ['asc']).map(
                  (subItem, key) => {
                    return (
                      <div className="pbf-sub-section-container" key={key}>
                        <div className="input-container">
                          <p>Sub-Section Name</p>
                          <Input
                            size="large"
                            value={subItem.name}
                            onChange={(e) =>
                              onSubSectionNameChange(e.target.value, index, key)
                            }
                          />
                        </div>
                        <div className="input-container">
                          <p>Control Type</p>
                          <Select
                            size="large"
                            options={PROPERTY_TEMPLTES}
                            value={subItem.type}
                            onChange={(value) =>
                              onSubSectionControlTypeChange(value, index, key)
                            }
                          />
                        </div>
                        <div>
                          <Popconfirm
                            placement="topLeft"
                            title={
                              'Are you sure you want to delete this sub section?'
                            }
                            onConfirm={() => onDeleteSubSection(index, key)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              className="delete-button"
                              size="large"
                              icon={<DeleteOutlined />}
                            />
                          </Popconfirm>
                        </div>
                      </div>
                    )
                  }
                )}
                <Button size="large" onClick={() => onAddSubSection(index)}>
                  <PlusOutlined className="plus-icon" />
                  Add a Sub-Section
                </Button>
              </Panel>
            )
          }
        )}
        <div className="line" />
        <Button
          onClick={onAddSection}
          size="large"
          className="add-section-button"
        >
          <PlusOutlined className="plus-icon" />
          Add a Section
        </Button>
      </Collapse>
    </div>
  )
}

export default WorkFlowForm
